import axios from "axios";
import { Message } from 'element-ui';
import router from "@/router";

const instance = axios.create({
    baseURL: "https://api.yfg8888.top",
    timeout: 30000
});

instance.interceptors.request.use(config => {
    if (config.method !== 'get') {
        config.headers["Content-Type"] = 'application/x-www-form-urlencoded';
    }
    // config.headers["Content-Type"] = 'application/x-www-form-urlencoded';
    const token = localStorage.getItem("backend-authorization-token")
    if (token && !config.url.endsWith("/login") && !config.url.endsWith("/captchaImage")) {
        config.headers["Authorization"] = "Bearer " + token
    }
    return config
}, err => {
    return Promise.reject(err)
})

instance.interceptors.response.use(res => {
    let res_data = res.data

    if (res_data.state != 0) {
        Message(res_data.error || '网络请求错误');

        if (res_data.state == 401) {
            // 删除token
            localStorage.removeItem("backend-authorization-token")
            // 跳转登录页面
            router.push("/login").catch(err => {
                console.log(err);
            })
        }

        return false
    }
    return res_data

}, err => {
    if (err.code === 'ECONNABORTED') {
        return 'timeout';
    }
    return Promise.reject(err)
})

export default instance